var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "spinner" }, [
    _c("div", {
      staticClass: "spinner__dot",
      class: { active: _vm.currentDot === 0 }
    }),
    _c("div", {
      staticClass: "spinner__dot",
      class: { active: _vm.currentDot === 1 }
    }),
    _c("div", {
      staticClass: "spinner__dot",
      class: { active: _vm.currentDot === 2 }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }